import { Link } from "react-router-dom";

const reviews = [
  { name: "追更阿青", text: "分类特别清楚，穿越和系统分得明明白白，再也不用大海捞针找作品了。" },
  { name: "木叶老粉", text: "更新整理得很及时，追更进度一目了然，已经收藏好几部连载中的了。" },
  { name: "同人爱好者", text: "从战斗到日常都有覆盖，介绍写得到位，评分热度也很靠谱。" },
];

export default function AboutTeaser() {
  return (
    <section className="container-x py-14 md:py-20" aria-labelledby="about-heading">
      <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            关于我们
          </span>
          <h2 id="about-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            让每一类火影同人都能被看到
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
            火影同人动漫是一处面向同人爱好者的作品整理与推荐站点。我们坚持按剧情类型对火影同人作品进行精细分类，围绕穿越、系统、重生、日常、战斗等方向持续整理，帮助大家快速定位对味的作品，不错过任何一部好作品。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            我们的内容原则很简单：分类清晰、简介真实、更新及时。不夸大、不堆砌，只把真正值得看的作品好好介绍给懂它的读者。
          </p>
          <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["16+", "精选作品"],
              ["5", "剧情分类"],
              ["每日", "持续更新"],
            ].map(([num, label]) => (
              <div key={label} className="flex items-baseline gap-2">
                <span className="font-heading text-2xl font-black text-primary-600">{num}</span>
                <span className="text-sm text-foreground-600">{label}</span>
              </div>
            ))}
          </div>
          <Link
            to="/about"
            className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-1">
          {reviews.map((r) => (
            <blockquote
              key={r.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">“{r.text}”</p>
              <footer className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-user-3-line" />
                </span>
                {r.name}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}